import SvgIcon from '../SvgIcon/SvgIcon';
import Text from '../Text/Text';
import './Checkbox.scss';

const Checkbox = ({
  inputId,
  dataTestId,
  label,
  isChecked = false,
  onChange,
  disabled = false,
  small = false,
}: {
  inputId: string;
  dataTestId?: string;
  isChecked?: boolean;
  onChange: () => void;
  label?: string;
  disabled?: boolean;
  small?: boolean;
}) => {
  return (
    <div className={`checkbox-container${disabled ? ' disabled' : ''}${small ? ' small' : ''}`}>
      <label>
        <input
          data-testid={dataTestId}
          id={`${inputId}-checkbox`}
          type="checkbox"
          defaultChecked={isChecked}
          onChange={onChange}
          className={isChecked ? 'checked' : ''}
          disabled={disabled}
        />
        {isChecked && (
          <SvgIcon
            data-testid={`${inputId}-check-svg`}
            iconName="Check"
            fill={disabled ? 'var(--black)' : 'var(--white)'}
            width={small ? 8 : 12}
            height={small ? 8 : 12}
          />
        )}
        {label && (
          <span className="body">
            <Text type="body">{label}</Text>
          </span>
        )}
      </label>
    </div>
  );
};

export default Checkbox;
